var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.527 0.908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.762,4.092H9.843a.3.3,0,0,0-.316.28V29.563a.3.3,0,0,0,.316.28H34.762a.3.3,0,0,0,.316-.28V4.372A.3.3,0,0,0,34.762,4.092Zm-.316,25.191H10.159V4.652H34.446ZM14.16,25.409a.3.3,0,0,1,.316-.28l15.575-.009h0a.282.282,0,1,1,0,.56l-15.575.009h0A.3.3,0,0,1,14.16,25.409Zm0-2.241a.3.3,0,0,1,.316-.28l15.575-.009h0a.282.282,0,1,1,0,.56l-15.575.009h0A.3.3,0,0,1,14.16,23.168Zm1.327-3.382h2.234a.3.3,0,0,0,.316-.28V16.47a.3.3,0,0,0-.316-.28H15.488a.3.3,0,0,0-.316.28v3.036A.3.3,0,0,0,15.488,19.786ZM15.8,16.75h1.6v2.476H15.8Zm3.457-2.211a.3.3,0,0,0-.316.28v4.687a.3.3,0,0,0,.316.28h2.234a.3.3,0,0,0,.316-.28V14.819a.3.3,0,0,0-.316-.28H19.26Zm1.918,4.687h-1.6V15.1h1.6ZM23.033,15.3a.3.3,0,0,0-.316.28v3.924a.3.3,0,0,0,.316.28h2.234a.3.3,0,0,0,.316-.28V15.582a.3.3,0,0,0-.316-.28Zm1.918,3.924h-1.6V15.862h1.6Zm1.539-6.283v6.563a.3.3,0,0,0,.316.28H29.04a.3.3,0,0,0,.316-.28V12.943a.3.3,0,0,0-.316-.28H26.806A.3.3,0,0,0,26.49,12.943Zm.632.28h1.6v6h-1.6ZM16.6,14.553a1,1,0,0,0,1.048-.929.826.826,0,0,0-.053-.291l2.154-1.378a1.131,1.131,0,0,0,.624.184,1.087,1.087,0,0,0,.876-.42l1.85.461a1.057,1.057,0,0,0,2.1-.03.844.844,0,0,0-.132-.45l2.4-2.242a1.15,1.15,0,0,0,.457.094,1,1,0,0,0,1.048-.929,1.056,1.056,0,0,0-2.1,0,.844.844,0,0,0,.132.45l-2.4,2.242a1.15,1.15,0,0,0-.457-.094,1.087,1.087,0,0,0-.876.42l-1.85-.461a1.057,1.057,0,0,0-2.1.03.826.826,0,0,0,.053.291L17.228,12.88A1.132,1.132,0,0,0,16.6,12.7a.935.935,0,1,0,0,1.857Zm11.319-6.3a.372.372,0,1,1-.417.369A.4.4,0,0,1,27.923,8.255ZM24.15,11.782a.372.372,0,1,1-.417.369A.4.4,0,0,1,24.15,11.782Zm-3.773-.94a.372.372,0,1,1-.417.369A.4.4,0,0,1,20.377,10.842ZM16.6,13.255a.372.372,0,1,1-.417.369A.4.4,0,0,1,16.6,13.255Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportedIcon);
export default __webpack_public_path__ + "static/media/reported-icon.d35dde0929aeb087fa5d0dafa6ccd6da.svg";
export { ForwardRef as ReactComponent };